import React, { useEffect, useState } from "react";
import {
  Box,
  CssBaseline,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Avatar,
  Badge,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
  makeStyles,
  InputBase,
  Paper,
} from "@material-ui/core";
import logoDark from "../img/banner.jpg";
import {
  getUserWorkSpaceList,
  getNavigationType,
  getAllUserCommunityList,
  getAnnouncementList,
  getAllCommonProfessionList,
} from "../redux/actions/commonApiActions";
import { workSpaceUserLogin } from "../redux/actions/loginDetailsActions";
import { getNotificationList } from "../redux/actions/notificationActions";
import {
  FiMenu,
  FiChevronLeft,
  FiChevronDown,
  FiChevronRight,
  FiUser,
  FiBell,
  FiSettings,
  FiUsers,
  FiLogOut,
  FiPlus,
  FiHash,
  FiMessageSquare,
  FiSearch,
  FiHelpCircle,
  FiX,
} from "react-icons/fi";
import NavigationRouter from "./NavigationRouter";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { API_URL } from "../config/app-config";
import { useDispatch, useSelector } from "react-redux";
import UserImg from "../components/UserImg";
import FriendsCardV2 from "../components/FriendsCardV2";
import { getWorkspaceCommunityList } from "../redux/actions/subjectActions";
import dummyimage_banner from "../img/Yuukke_Cover.jpg";
import { AiOutlineHome, AiOutlineSolution } from "react-icons/ai";
import { BiGroup } from "react-icons/bi";
import { MdOutlineEventNote, MdOutlineLibraryBooks } from "react-icons/md";
import { TiAttachment } from "react-icons/ti";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import Hoc from "../Hoc";
import GroupCardV2 from "../components/GroupCardV2";
import Header from "../components/Header/Header";
import Swal from "sweetalert2";
import AuthService from "../session/AuthService";
import Http from "../api/Http";
import { getLogoutData } from "../redux/actions/logoutActions";
import { useHistory } from "react-router-dom";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import clsx from "clsx";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: "#f8f9fa",
    height: "100vh",
    overflow: "hidden",
    fontFamily: "'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: "linear-gradient(135deg, #1e2857 0%, #26507b 100%)",
    boxShadow: "none",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 55,
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(1),
    color: "white",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 4,
    padding: 6,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.25)",
    },
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    height: "100%",
  },
  drawerOpen: {
    width: drawerWidth,
    background: "linear-gradient(180deg, #1e2857 0%, #1e2857 100%)",
    color: "#d1d2d3",
    borderRight: "1px solid rgba(255, 255, 255, 0.1)",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#4a4a4a",
      borderRadius: "3px",
    },
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
    background: "linear-gradient(135deg,#130d1a 75%,#2c1f3e 100%)",
    color: "#d1d2d3",
    borderRight: "1px solid rgba(255, 255, 255, 0.1)",
    height: "100%",
    overflowY: "auto",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    // justifyContent: "flex-end",
    justifyContent: "space-between",
    padding: theme.spacing(0, 2),
    minHeight: 48,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
    height: "100vh",
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: "#f8f9fa",
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    // overflow: "hidden",
    // border: "1px solid red",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    height: 48,
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    backgroundColor: "rgba(29, 28, 29, 0.9)",
  },
  logoText: {
    fontWeight: 900,
    fontSize: "1.2rem",
    color: "#ffffff",
    marginLeft: 12,
    fontFamily: "'Lato', sans-serif",
    letterSpacing: "-0.5px",
  },
  listItem: {
    borderRadius: 4,
    margin: "2px 8px",
    padding: "8px 12px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.12)",
    },
  },
  listItemActive: {
    backgroundColor: "rgba(255,255,255,0.16) !important",
    borderRadius: "4px",
    margin: "2px 8px",
    borderLeft: "3px solid #ffffff",
    paddingLeft: "9px",
  },
  listItemIcon: {
    minWidth: 0,
    marginRight: 12,
    color: "#d1d2d3",
    fontSize: "1rem",
  },
  listItemText: {
    "& span": {
      fontWeight: 500,
      fontSize: "0.9rem",
      color: "#d1d2d3",
      fontFamily: "'Lato', sans-serif",
    },
  },
  subListItem: {
    paddingLeft: theme.spacing(6),
    margin: "2px 8px",
    borderRadius: 4,
    padding: "8px 12px",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.08)",
    },
  },
  workspaceSelect: {
    minWidth: 200,
    "& .MuiSelect-root": {
      display: "flex",
      alignItems: "center",
      padding: "6px 12px",
      borderRadius: 4,
      background: "rgba(255, 255, 255, 0.1)",
      border: "1px solid rgba(255, 255, 255, 0.15)",
      color: "white",
      height: 32,
      "&:focus": {
        background: "rgba(255, 255, 255, 0.2)",
      },
    },
    "& .MuiSelect-icon": {
      color: "white",
      right: 8,
    },
  },
  badge: {
    "& .MuiBadge-badge": {
      background: "#e01e5a",
      color: "white",
      fontWeight: 600,
      fontSize: "0.65rem",
      height: 18,
      minWidth: 18,
      border: "2px solid #1d1c1d",
    },
  },
  avatar: {
    width: 28,
    height: 28,
    border: "1px solid rgba(255, 255, 255, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#fff",
      transform: "scale(1.05)",
    },
  },
  profileMenu: {
    "& .MuiPaper-root": {
      backgroundColor: "#1d1c1d",
      color: "#d1d2d3",
      borderRadius: 6,
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.25)",
      minWidth: 220,
      marginTop: 48,
      "& .MuiMenuItem-root": {
        padding: "8px 16px",
        fontSize: "0.9rem",
        "&:hover": {
          backgroundColor: "rgba(255,255,255,0.12)",
        },
      },
    },
  },
  rightSidebar: {
    width: 280,
    background: "#ffffff",
    borderRadius: 0,
    borderLeft: "1px solid #e1e4e8",
    padding: theme.spacing(0),
    height: "calc(90vh - 48px)",
    // height: "calc(85vh - 48px)",
    position: "fixed",
    marginTop: 10,
    right: 0,
    top: 48,
    // overflowY: "hidden",
    overflowY: "hidden",
    boxShadow: "-1px 0 5px rgba(0,0,0,0.05)",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    // border: "1px solid red",
  },
  sidebarHeader: {
    padding: "12px 16px",
    backgroundColor: "#fff",
    borderBottom: "1px solid #e1e4e8",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& h6": {
      fontWeight: 700,
      color: "#1d1c1d",
      margin: 0,
      fontSize: "0.95rem",
      fontFamily: "'Lato', sans-serif",
    },
  },
  friendsListContainer: {
    padding: "8px 0",
    height: "calc(100vh - 120px)",
    // overflowY: "auto",
    overflowY: "hidden",
  },
  mainContent: {
    flex: 1,
    backgroundColor: "#ffffff",
    borderRadius: 8,
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    padding: theme.spacing(3),
    minHeight: "calc(100vh - 48px - 24px)",
    margin: 12,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
      margin: 8,
    },
  },
  flexContainer: {
    display: "flex",
    width: "100%",
    marginTop: 0,
    height: "100%",
  },
  contentArea: {
    flex: 1,
    marginRight: 280,
    height: "100%",
    [theme.breakpoints.down("md")]: {
      marginRight: 0,
    },
  },
  slackLogo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 28,
    height: 28,
    background: "linear-gradient(135deg, #4A154B 0%, #2A0B2D 100%)",
    borderRadius: 6,
    color: "white",
    fontWeight: 700,
    fontSize: "1.2rem",
  },
  workspaceMenuItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: "8px 8px",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.1)",
    },
  },
  workspaceLogo: {
    width: 24,
    height: 24,
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.9rem",
    fontWeight: 700,
    background: "rgba(255,255,255,0.15)",
  },
  workspaceInfo: {
    flex: 1,
    minWidth: 0,
  },
  workspaceName: {
    fontWeight: 500,
    fontSize: "0.9rem",
    color: "#ffffff",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  workspaceSlug: {
    fontSize: "0.75rem",
    color: "rgba(255,255,255,0.7)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  sidebarDivider: {
    margin: "8px 0",
    backgroundColor: "rgba(255,255,255,0.1)",
  },
  statusIndicator: {
    position: "absolute",
    bottom: -2,
    right: -2,
    width: 10,
    height: 10,
    backgroundColor: "#2bac76",
    borderRadius: "50%",
    border: "2px solid #1d1c1d",
  },
  sidebarHeaderText: {
    padding: "8px 16px 4px",
    color: "rgba(255,255,255,0.5)",
    fontSize: "0.7rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginTop: 8,
  },
  sidebarSection: {
    padding: "4px 0",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
  },
  channelHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 16px 4px",
    "& h6": {
      color: "rgba(255,255,255,0.7)",
      fontSize: "0.8rem",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      margin: 0,
    },
    "& button": {
      color: "rgba(255,255,255,0.5)",
      padding: 4,
      "&:hover": {
        color: "white",
        backgroundColor: "rgba(255,255,255,0.15)",
        borderRadius: 4,
      },
    },
  },
  channelItem: {
    padding: "6px 16px 6px 44px",
    fontSize: "0.9rem",
    color: "rgba(255,255,255,0.8)",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.08)",
    },
    "& svg": {
      marginRight: 8,
      fontSize: "0.8rem",
      color: "rgba(255,255,255,0.6)",
    },
  },
  userStatus: {
    display: "flex",
    alignItems: "center",
    // padding: "8px 16px",
    marginTop: 8,
    "& div": {
      fontSize: "0.8rem",
      color: "rgba(255,255,255,0.7)",
    },
  },
  activeDot: {
    width: 8,
    height: 8,
    backgroundColor: "#2bac76",
    borderRadius: "50%",
    marginRight: 8,
  },
  topBarActions: {
    display: "flex",
    alignItems: "center",
    "& > *": {
      marginLeft: 8,
    },
  },
  searchBar: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "rgba(255,255,255,0.15)",
    borderRadius: 4,
    padding: "4px 8px",
    margin: "0 16px",
    flex: 1,
    maxWidth: 500,
    "& input": {
      background: "transparent",
      border: "none",
      color: "white",
      padding: "4px 8px",
      fontSize: "0.9rem",
      width: "100%",
      "&:focus": {
        outline: "none",
      },
      "&::placeholder": {
        color: "rgba(255,255,255,0.5)",
      },
    },
    "& svg": {
      color: "rgba(255,255,255,0.5)",
    },
  },
  sidebarFooter: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "linear-gradient(135deg,#130d1a 75%,#2c1f3e 100%)",
    borderTop: "1px solid rgba(255,255,255,0.1)",
    padding: "8px 12px",
    display: "flex",
    alignItems: "center",
  },
  sidebarFooterInfo: {
    marginLeft: 12,
    flex: 1,
    "& h6": {
      fontSize: "0.9rem",
      fontWeight: 600,
      color: "white",
      margin: 0,
    },
    "& p": {
      fontSize: "0.75rem",
      color: "rgba(255,255,255,0.7)",
      margin: 0,
    },
  },
  logoContainers: {
    display: "flex",
    alignItems: "center",
    // border: "1px solid red",
    width: "max-content",
    // marginRight: "89.5rem",
  },

  logoImage: {
    height: "30px",
    width: "auto",
    objectFit: "contain",
  },

  workspaceDropdown: {
    padding: "8px 12px",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
  },
}));

const NavPanelOne = (props) => {
  const classes = useStyles();
  const { t } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const [expandedMenu, setExpandedMenu] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeItem, setActiveItem] = useState("Feed");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { list } = useSelector((state) => state.notification);
  const { userWorkSpaceList } = useSelector((state) => state.commonApi);

  const handleWorkspaceChange = (event) => {
    const selectedValue = event.target.value;

    // Special handling for Default workspace
    if (selectedValue === "default") {
      const defaultWorkspace = userWorkSpaceList.find(
        (ws) => ws.workSpaceName === "Default"
      );

      if (!defaultWorkspace) {
        console.error("Default workspace not found");
        return;
      }

      sessionStorage.setItem("WORKSPACE", "default");
      dispatch(workSpaceUserLogin(0));
      history.push(`/default/home`);
      return;
    }

    // Handle numeric workspace IDs
    const selectedWorkspaceId = Number(selectedValue);
    const selectedWorkspace = userWorkSpaceList.find(
      (ws) => ws.workSpaceId === selectedWorkspaceId
    );

    if (!selectedWorkspace?.slug) {
      console.error("Invalid workspace selection", {
        selectedWorkspaceId,
        userWorkSpaceList,
      });
      return;
    }

    sessionStorage.setItem("WORKSPACE", selectedWorkspace.slug);
    dispatch(workSpaceUserLogin(selectedWorkspaceId));
    history.push(`/${selectedWorkspace.slug}/home`);
  };

  const friendDescription = (id) => {
    if (id) {
      props.history.push(`/${workspaceName}/friendDescription/${id}`, {
        from: window.location.pathname,
      });
    }
  };

  const [state, setState] = useState({
    communityList: [],
    openSubMenu: false,
    menuType: "",
  });
  const updateState = (name, value) => {
    setState((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const { loginDetails, authUser } = useSelector(
    (state) => state.loginDetailsApi
  );
  const workspaceName = useSelector(
    (state) =>
      state.loginDetailsApi.loginDetails.userWorkSpace?.slug ?? "default"
  );
  const currentWorkspaceId = loginDetails?.userWorkSpace?.workSpaceId;
  useEffect(() => {
    dispatch(getUserWorkSpaceList());
  }, [dispatch]);
  const { getWorkspaceSubjects } = useSelector((state) => state.subjects);

  useEffect(() => {
    dispatch(getAllCommonProfessionList());
  }, [dispatch]);

  useEffect(() => {
    if (loginDetails?.userWorkSpace?.slug) {
      window.history.replaceState(
        null,
        "",
        `/${loginDetails.userWorkSpace.slug}/home`
      );
    }
  }, [loginDetails?.userWorkSpace?.slug]);

  useEffect(() => {
    if (!userWorkSpaceList || userWorkSpaceList.length === 0) {
      dispatch(getUserWorkSpaceList({ forceReload: true }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (loginDetails?.userWorkSpace?.workSpaceId !== undefined) {
      setMenuList((prev) => {
        const newItems = [...prev];
        const userListIndex = newItems.findIndex(
          (item) => item.title === "User List"
        );

        // Add/remove User List based on workspace ID
        if (loginDetails.userWorkSpace.workSpaceId !== 0) {
          if (userListIndex === -1) {
            newItems.splice(2, 0, {
              title: "User List",
              icon: <FiUsers />,
              route: "userList",
            });
          }
        } else if (userListIndex !== -1) {
          newItems.splice(userListIndex, 1);
        }

        return newItems;
      });
    }
  }, [loginDetails?.userWorkSpace?.workSpaceId]);

  useEffect(() => {
    if (loginDetails?.userWorkSpace?.slug) {
      const expectedPath = `/${loginDetails.userWorkSpace.slug}/home`;
      if (window.location.pathname !== expectedPath) {
        history.replace(expectedPath);
      }
    }
  }, [loginDetails?.userWorkSpace?.slug, history]);

  const loading = useSelector((state) => state.commonApi.loading);
  useEffect(() => {
    let data = {
      searchKey: "",
      filterKeys: [],
      tagIds: [],
      type: "myCommunity",
      subjectId: 0,
    };
    dispatch(getWorkspaceCommunityList(data));
  }, []);

  const [menuItems, setMenuList] = useState([
    {
      title: "Feed",
      icon: <AiOutlineHome style={{ fontSize: "1.1rem" }} />,
      route: "home",
    },
    {
      title: "People",
      icon: <FiUsers style={{ fontSize: "1.1rem" }} />,
      route: "mynetwork",
    },
    {
      title: "Groups",
      route: "groupsList",
      icon: <BiGroup style={{ fontSize: "1.1rem" }} />,
      submenu: null,
    },
    {
      title: "Learning Hub",
      icon: <MdOutlineLibraryBooks style={{ fontSize: "1.1rem" }} />,
      route: "learning-hub",
    },
    {
      title: "Calendar",
      icon: <MdOutlineEventNote style={{ fontSize: "1.1rem" }} />,
      route: "calendar",
    },
    {
      title: "Mentor",
      icon: <AiOutlineSolution style={{ fontSize: "1.1rem" }} />,
      route: "mentors",
    },
    {
      title: "My Documents",
      icon: <TiAttachment style={{ fontSize: "1.1rem" }} />,
      route: "my-documents",
    },
  ]);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleMenuExpand = (title, route, submenu) => {
    setActiveItem(title);
    props.history.push(`/${workspaceName}/${route}`);
    setExpandedMenu(expandedMenu === title ? "" : title);
    updateState("openSubMenu", submenu ? true : false);
    updateState("menuType", "friends");
  };

  const handleSubMenu = (route, type, id) => {
    if (type === "group" && id) {
      setState((previous) => ({
        ...previous,
        menuType: "group",
        subjectId: id,
      }));
    } else {
      updateState("menuType", "friends");
    }
    props.history.push(`/${workspaceName}/${route}`);
  };

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileClose = () => {
    setAnchorEl(null);
  };

  const viewProfile = () => {
    props.history.push(`/my-profile`);
    handleProfileClose();
  };

  const logout = (e) => {
    handleProfileClose();

    e.preventDefault();
    e.stopPropagation();
    Swal.fire({
      title: t("Are you sure?"),
      text: t("You want to logout?"),
      icon: "warning",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: t("Yes, logout"),
      cancelButtonText: t("No, cancel!"),
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: t("Logout Successfully"),
          icon: "info",
          type: "info",
          showConfirmButton: true,
        }).then((result) => {
          AuthService.removeAuth();
          localStorage.removeItem("R_TOKEN");
          dispatch(getLogoutData());
          if (Http.isProfileExists("keycloak")) {
            AuthService.triggerLogout();
          }
        });
      }
    });
  };

  return (
    <Box display="flex" className={classes.root}>
      <CssBaseline />
      {loading && authUser?.type && <Hoc />}
      {authUser?.type && <Header isNavPanel={true} />}
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.logoContainers}>
            <img
              src={logoDark}
              alt="Company Logo"
              className={classes.logoImage}
            />
          </div>

          {/* <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
            className={classes.menuButton}
          >
            <FiMenu />
          </IconButton> */}
          {/* 
          <div className={classes.searchBar}>
            <FiSearch />
            <input placeholder="Search" />
          </div> */}

          <div style={{ display: "flex" }}>
            <div className="workspace-menu-v1">
              <FormControl
                variant="standard"
                className={classes.workspaceSelect}
              >
                <Select
                  value={
                    loginDetails?.userWorkSpace?.slug === "default"
                      ? "default"
                      : currentWorkspaceId || ""
                  }
                  onChange={handleWorkspaceChange}
                  displayEmpty
                  inputProps={{ "aria-label": "Select Workspace" }}
                  renderValue={(selected) => {
                    const isDefault = selected === "default";
                    const workspace = isDefault
                      ? userWorkSpaceList?.find(
                          (ws) => ws.workSpaceName === "Default"
                        )
                      : userWorkSpaceList?.find(
                          (ws) => ws.workSpaceId === selected
                        );

                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            width: "28px",
                            height: "28px",
                            borderRadius: "6px",
                            backgroundColor: "rgba(255,255,255,0.15)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          {workspace?.logo ? (
                            <img
                              src={`${API_URL}auth/image/${workspace.logo}`}
                              alt="workspace-logo"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                color: "white",
                                fontWeight: 600,
                                fontSize: "14px",
                              }}
                            >
                              {workspace?.workSpaceName?.charAt(0) || "B"}
                            </div>
                          )}
                        </div>
                        <span
                          style={{
                            fontWeight: 500,
                            fontSize: "1rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "150px",
                          }}
                        >
                          {workspace?.workSpaceName === "Default"
                            ? "Betamonks"
                            : workspace?.workSpaceName}
                        </span>
                      </div>
                    );
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        backgroundColor: "#1d1c1d",
                        color: "white",
                        borderRadius: "8px",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
                        marginTop: "45px",
                      },
                    },
                  }}
                >
                  {/* Default Workspace */}
                  <MenuItem
                    value="default"
                    key="default-workspace"
                    className={classes.workspaceMenuItem}
                  >
                    <div className={classes.workspaceLogo}>B</div>
                    <div className={classes.workspaceInfo}>
                      <div className={classes.workspaceName}>Betamonks</div>
                      <div className={classes.workspaceSlug}>
                        Default Workspace
                      </div>
                    </div>
                  </MenuItem>

                  <Divider className={classes.sidebarDivider} />

                  {/* Other Workspaces */}
                  {userWorkSpaceList
                    ?.filter((ws) => ws.workSpaceId)
                    ?.map((workspace) => (
                      <MenuItem
                        key={workspace.workSpaceId}
                        value={workspace.workSpaceId}
                        className={classes.workspaceMenuItem}
                      >
                        <div className={classes.workspaceLogo}>
                          {workspace.logo ? (
                            <img
                              src={`${API_URL}auth/image/${workspace.logo}`}
                              alt="workspace-logo"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            workspace.workSpaceName.charAt(0)
                          )}
                        </div>
                        <div className={classes.workspaceInfo}>
                          <div className={classes.workspaceName}>
                            {workspace.workSpaceName}
                          </div>
                          {workspace.slug && (
                            <div className={classes.workspaceSlug}>
                              {workspace.slug}
                            </div>
                          )}
                        </div>
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>

            <div className={classes.topBarActions}>
              {/* <IconButton
              color="inherit"
              onClick={() =>
                handleMenuExpand("Help", "help-center", null)
              }
            >
              <FiHelpCircle style={{ height: "1.2rem", width: "auto" }} />
            </IconButton> */}

              <IconButton
                color="inherit"
                onClick={() =>
                  handleMenuExpand("Notification", "notification", null)
                }
              >
                <Badge
                  badgeContent={list?.length ?? 0}
                  color="error"
                  className={classes.badge}
                >
                  <FiBell style={{ height: "1.2rem", width: "auto" }} />
                </Badge>
              </IconButton>

              <div style={{ position: "relative" }}>
                <IconButton
                  color="inherit"
                  onClick={handleProfileClick}
                  className={classes.avatar}
                >
                  <UserImg
                    size="tiny"
                    imgSrc={`${API_URL}auth/image/${loginDetails?.profile_uuid}`}
                    imgAlt={"img"}
                    isShowStatus={false}
                  />
                </IconButton>
                <div className={classes.statusIndicator}></div>
              </div>
            </div>
          </div>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleProfileClose}
            className={classes.profileMenu}
          >
            <MenuItem
              onClick={() => viewProfile()}
              style={{ color: "#d1d2d3" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  width: "100%",
                }}
              >
                <FiUser style={{ color: "#d1d2d3", fontSize: "1.1rem" }} />
                <div>Profile</div>
              </div>
            </MenuItem>
            <MenuItem onClick={(e) => logout(e)} style={{ color: "#d1d2d3" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  width: "100%",
                }}
              >
                <FiLogOut style={{ color: "#d1d2d3", fontSize: "1.1rem" }} />
                <div>Logout</div>
              </div>
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.logoContainer}>
          <div className={classes.slackLogo}>
            <Typography variant="h6" style={{ fontWeight: 700 }}>
              B
            </Typography>
          </div>
          <Typography variant="h6" className={classes.logoText}>
            Betamonks
          </Typography>
        </div>

        {/* <div className={classes.sidebarSection}>
          <Typography variant="body2" className={classes.sidebarHeaderText}>
            Channels
          </Typography>
          <List style={{ padding: "0" }}>
            <div className={classes.channelHeader}>
              <Typography variant="subtitle2">Channels</Typography>
              <IconButton size="small">
                <FiPlus />
              </IconButton>
            </div>
            <div className={classes.channelItem}>
              <FiHash />
              <span>general</span>
            </div>
            <div className={classes.channelItem}>
              <FiHash />
              <span>random</span>
            </div>
            <div className={classes.channelItem}>
              <FiHash />
              <span>announcements</span>
            </div>
          </List>
        </div> */}

        <div className={classes.sidebarSection}>
          {/* <Typography variant="body2" className={classes.sidebarHeaderText}>
            Direct Messages
          </Typography> */}
          <List style={{ padding: "8px 0" }}>
            {menuItems.map((item) => (
              <React.Fragment key={item.title}>
                <ListItem
                  button
                  className={clsx(classes.listItem, {
                    [classes.listItemActive]: activeItem === item.title,
                  })}
                  onClick={() =>
                    handleMenuExpand(item.title, item.route, item.submenu)
                  }
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.title}
                    className={classes.listItemText}
                  />
                  {item.submenu && (
                    <IconButton size="small" style={{ color: "#d1d2d3" }}>
                      {expandedMenu === item.title ? (
                        <FiChevronDown />
                      ) : (
                        <FiChevronRight />
                      )}
                    </IconButton>
                  )}
                </ListItem>
                {state.openSubMenu && item.submenu && (
                  <Collapse
                    in={expandedMenu === item.title}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div">
                      {item.submenu.map((subItem) => (
                        <ListItem
                          button
                          key={subItem.name}
                          onClick={() =>
                            handleSubMenu(
                              subItem.route,
                              subItem.type,
                              subItem.id
                            )
                          }
                          className={classes.subListItem}
                        >
                          {subItem?.type === "group" && (
                            <img
                              style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "4px",
                                marginRight: "10px",
                                objectFit: "cover",
                              }}
                              src={
                                subItem.image
                                  ? subItem.image
                                  : dummyimage_banner
                              }
                              alt="group"
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = dummyimage_banner;
                              }}
                            />
                          )}
                          <Typography
                            variant="body2"
                            style={{ fontSize: "0.9rem", color: "#d1d2d3" }}
                          >
                            {subItem.name}
                          </Typography>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>
        </div>

        <div className={classes.sidebarSection}>
          <Typography variant="body2" className={classes.sidebarHeaderText}>
            Activity
          </Typography>
          <List style={{ padding: "0" }}>
            <ListItem
              button
              className={clsx(classes.listItem, {
                [classes.listItemActive]: activeItem === "Notification",
              })}
              onClick={() =>
                handleMenuExpand("Notification", "notification", null)
              }
            >
              <ListItemIcon className={classes.listItemIcon}>
                <FiBell style={{ fontSize: "1.1rem" }} />
              </ListItemIcon>
              <ListItemText
                primary="Notifications"
                className={classes.listItemText}
              />
              <Badge
                badgeContent={list?.length ?? 0}
                color="error"
                className={classes.badge}
                style={{ marginRight: 8 }}
              />
            </ListItem>
          </List>
        </div>

        <div className={classes.sidebarFooter}>
          <UserImg
            size="tiny"
            imgSrc={`${API_URL}auth/image/${loginDetails?.profile_uuid}`}
            imgAlt={"img"}
            isShowStatus={false}
          />
          <div className={classes.sidebarFooterInfo}>
            <Typography variant="subtitle1">{loginDetails?.dName}</Typography>
            <div className={classes.userStatus}>
              <div className={classes.activeDot}></div>
              <div>Active</div>
            </div>
          </div>
          <IconButton
            size="small"
            onClick={() => viewProfile()}
            style={{ color: "rgba(255,255,255,0.7)" }}
          >
            <FiSettings />
          </IconButton>
        </div>
      </Drawer>

      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <div className={classes.toolbar} />
        <div className={classes.flexContainer}>
          <div className={classes.contentArea}>
            <div className={classes.mainContent}>
              <NavigationRouter />
            </div>
          </div>

          <div className={classes.rightSidebar}>
            <div className={classes.sidebarHeader}>
              <Typography variant="h6">
                <FiUsers style={{ marginRight: 8 }} />
                {state.menuType === "group"
                  ? "Group Members"
                  : "Active People"}
              </Typography>
            </div>
            <div className={classes.friendsListContainer}>
              {state.menuType === "group" ? (
                <GroupCardV2
                  subjectId={state.subjectId}
                  friendDescription={friendDescription}
                />
              ) : (
                <FriendsCardV2
                  history={history}
                  workSpaceName={workspaceName}
                  friendDescription={friendDescription}
                />
              )}
            </div>
          </div>
        </div>
      </main>
    </Box>
  );
};

export default withTranslation()(withRouter(NavPanelOne));
